<div class="cover">
  <slot />
</div>

<style>
  .cover {
    background: white;
    max-width: 960px;
    margin: 0 auto;
  }
</style>
